module.exports = __webpack_public_path__ + "static/img/Daniel-Saifiti.e4f9d16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daniel-Saifiti.jpg
// module id = cDaF
// module chunks = 0